import React from 'react';
import NumberFormat from 'react-number-format';
import * as PropTypes from 'prop-types';

function NumberFormatCurrency(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator=" "
            allowNegative={false}
            decimalScale={2}
            decimalSeparator=","
            isNumericString
        />
    );
}

NumberFormatCurrency.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumberFormatCurrency;